import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", accentIndex = 1 }) => (
  <h1 className={className} data-testid="hero-kinetic-title">
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${i === accentIndex ? "italic text-clay" : ""}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.15 * i + 0.25, duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Overline = ({ children, light = false }) => (
  <p className={`text-xs uppercase tracking-[0.25em] font-semibold mb-6 ${light ? "text-cream/60" : "text-clay"}`}>
    {children}
  </p>
);
